import { OidcReducer, UserState } from '../../util/UserManager'

export type TOidcState = UserState
export default OidcReducer
